import createActionType from "@/redux/utils/createActionType";

export const MODULE = "notifications";

export const SET_NOTIFICATION = createActionType(MODULE, "setNotification");
export const SET_NOTIFICATION_TYPE = createActionType(MODULE, "setNotificationType");
export const SET_LAST_NOTIFICATION = createActionType(MODULE, "setLastNotification");
export const SET_ALL_CHAT_NOTIFICATIONS = createActionType(MODULE, "setAllChatNotifications");
export const MARK_CHAT_NOTIFICATION_READ = createActionType(MODULE, "markChatNotificationRead");
export const MARK_ALL_CHAT_NOTIFICATIONS_READ = createActionType(
  MODULE,
  "markAllChatNotificationsRead"
);
export const DELETE_CHAT_NOTIFICATION = createActionType(MODULE, "deleteChatNotification");
export const RESET = createActionType(MODULE, "reset");
